import statuses from './statuses';

export const load = (app) => {
	app.constant('STATUSES', statuses());
};


// WEBPACK FOOTER //
// ./src/js/constants/loader.js